import React, { useCallback, useState, useRef, useMemo } from 'react'
import { Flex } from '../../Components/Common/Flex'
import { Text } from '../../Components/Common/Text'
import { FC } from '../../Services/FeathersClient'
/* global Worker */

export const NewSollecito = () => {
  const [rows, setRows] = useState([])
  const [error, setError] = useState('')
  const [emailBody, setEmailBody] = useState('')
  const [title, setTitle] = useState('')
  const [loading, setLoading] = useState(false)
  const [sending, setSending] = useState(false)
  const [success, setSuccess] = useState('')
  const sendingRef = useRef(false)
  const [sentForCurrentLoad, setSentForCurrentLoad] = useState(false)
  // sorting state: field can be 'status' (extendable), dir is 'asc'|'desc' or null
  const [sort, setSort] = useState({ field: null, dir: null })

  const handleFile = useCallback(async (e) => {
    setError('')
    const file = e.target.files && e.target.files[0]
    if (!file) return
    setLoading(true)
    // a new file is being processed -> reset sent flag
    setSentForCurrentLoad(false)
    try {
      const data = await file.arrayBuffer()
      const required = ['Data Inizio', 'pax', 'Riferimento c/o T.O.', 'mail1', 'Voucher']

      // parse the workbook in a Web Worker to avoid blocking the UI
      const workerCode = `
        self.importScripts('https://cdn.jsdelivr.net/npm/xlsx/dist/xlsx.full.min.js');
        self.onmessage = function(e) {
          try {
            // immediately notify that parsing started (small non-zero value so UI shows activity)
            self.postMessage({ type: 'progress', percent: 0.1 })
            const arrayBuffer = e.data.arrayBuffer
            const required = (e.data.required || []).map(r => String(r || '').toLowerCase())
            // enable cellDates so date cells are returned as JS Date when possible
            const workbook = XLSX.read(arrayBuffer, { type: 'array', cellDates: true })
            // after workbook read, update progress
            self.postMessage({ type: 'progress', percent: 1 })
            const sheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[sheetName]
            const sheetAsArray = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' })
            // helper: convert an Excel cell (Date object or serial number or string) to YYYY-MM-DD
            function formatExcelDateCell(val) {
              if (val instanceof Date) {
                const y = val.getFullYear()
                const m = ('' + (val.getMonth() + 1)).padStart(2, '0')
                const d = ('' + val.getDate()).padStart(2, '0')
                return y + '-' + m + '-' + d
              }
              if (typeof val === 'number') {
                if (typeof XLSX.SSF !== 'undefined' && typeof XLSX.SSF.parse_date_code === 'function') {
                  const parsed = XLSX.SSF.parse_date_code(val)
                  if (parsed && parsed.y) {
                    const y = parsed.y
                    const m = ('' + parsed.m).padStart(2, '0')
                    const d = ('' + parsed.d).padStart(2, '0')
                    return y + '-' + m + '-' + d
                  }
                }
                try {
                  const epoch = new Date(Date.UTC(1899, 11, 30))
                  const ms = Math.round(val * 24 * 60 * 60 * 1000)
                  const dt = new Date(epoch.getTime() + ms)
                  const y = dt.getFullYear()
                  const m = ('' + (dt.getMonth() + 1)).padStart(2, '0')
                  const d = ('' + dt.getDate()).padStart(2, '0')
                  return y + '-' + m + '-' + d
                } catch (ex) {
                  return String(val)
                }
              }
              return String(val || '')
            }

            // after conversion to array, update progress
            self.postMessage({ type: 'progress', percent: 5 })
            const headerRow = Array.isArray(sheetAsArray) && sheetAsArray.length > 0 ? sheetAsArray[0] : []
            const headerLower = headerRow.map(h => String(h || '').toLowerCase())
            const missing = required.filter((h) => !headerLower.includes(String(h).toLowerCase()))
            if (missing.length > 0) {
              // map missing back to nicer names where possible
              const pretty = missing.map(m => m).join(', ')
              self.postMessage({ type: 'error', message: 'Mancano colonne richieste: ' + pretty })
              return
            }
            const headerIndexByLower = {}
            headerLower.forEach((h, idx) => { headerIndexByLower[h] = idx })

            const rowsArray = sheetAsArray.slice(1)
            const total = rowsArray.length
            if (total === 0) {
              // nothing to parse
              self.postMessage({ type: 'done', parsed: [], rowErrors: [] })
              return
            }
            const chunkSize = 100
            const parsed = []
            const rowErrors = []

            let i = 0
            let processed = 0
            let lastPercent = 0
            while (i < total) {
              const end = Math.min(i + chunkSize, total)
              for (let j = i; j < end; j++) {
                const rowArr = rowsArray[j]
                const isEmptyRow = !rowArr || (Array.isArray(rowArr) && rowArr.every((c) => String(c || '').trim() === ''))
                if (isEmptyRow) {
                  processed += 1
                  const percent = Math.round((processed / Math.max(1, total)) * 1000) / 10
                  if (percent !== lastPercent) {
                    lastPercent = percent
                    self.postMessage({ type: 'progress', percent })
                  }
                  continue
                }
                // safely read cells by header name (case-insensitive)
                const getCell = (name) => {
                  const idx = headerIndexByLower[String(name || '').toLowerCase()]
                  return (idx !== undefined && rowArr && rowArr[idx] !== undefined) ? rowArr[idx] : ''
                }

                // also build a raw object mapping header->value so server can access raw.mail1 etc.
                const rObj = {}
                headerRow.forEach((h, idx) => {
                  rObj[h] = rowArr && rowArr[idx] !== undefined ? rowArr[idx] : ''
                })

                const rawDate = getCell('Data Inizio')
                const voucherVal = getCell('Voucher') || getCell('voucher') || ''
                const p = {
                  id: parsed.length,
                  dataInizio: formatExcelDateCell(rawDate),
                  pax: getCell('pax') || '',
                  riferimento: getCell('Riferimento c/o T.O.') || '',
                  mail1: getCell('mail1') || '',
                  mail2: getCell('mail2') || '',
                  mail3: getCell('mail3') || '',
                  voucher: voucherVal,
                  raw: rObj
                }
                const missingFields = []
                if (!String(p.dataInizio || '').trim()) missingFields.push('Data Inizio')
                if (!String(p.pax || '').trim()) missingFields.push('pax')
                if (!String(p.riferimento || '').trim()) missingFields.push('Riferimento c/o T.O.')
                if (!String(p.mail1 || '').trim()) missingFields.push('mail1')
                if (!String(p.voucher || '').trim()) missingFields.push('Voucher')
                if (missingFields.length > 0) rowErrors.push({ row: j + 2, missing: missingFields })
                parsed.push(p)
                processed += 1
                const percent = Math.round((processed / Math.max(1, total)) * 1000) / 10
                if (percent !== lastPercent) {
                  lastPercent = percent
                  self.postMessage({ type: 'progress', percent })
                }
              }
              i = end
            }

            // deduplicate by voucher (keep first occurrence). normalize by trimming and lowercasing
            const seen = new Set()
            const deduped = []
            parsed.forEach((p) => {
              const key = String(p.voucher || '').trim().toLowerCase()
              if (key === '') {
                // keep empty vouchers as-is (they were already reported as missing if required)
                deduped.push(p)
              } else if (!seen.has(key)) {
                seen.add(key)
                deduped.push(p)
              } else {
                // duplicate - skip (keep first)
              }
            })

            self.postMessage({ type: 'done', parsed: deduped, rowErrors })
          } catch (err) {
            self.postMessage({ type: 'error', message: String(err) })
          }
        }
      `

      const blob = new Blob([workerCode], { type: 'text/javascript' })
      const objectUrl = URL.createObjectURL(blob)
      const worker = new Worker(objectUrl)
      // revoke the object URL immediately - worker keeps the script loaded
      try { URL.revokeObjectURL(objectUrl) } catch (e) { /* ignore */ }

      worker.onmessage = function (ev) {
        const data = ev.data
        if (data.type === 'progress') {
          // progress messages are ignored (UI no longer shows percentage)
          return
        }
        if (data.type === 'error') {
          setError('Errore nel parsing del file: ' + data.message)
          setRows([])
          worker.terminate()
          setLoading(false)
          return
        }
        if (data.type === 'done') {
          const parsed = data.parsed || []
          const rowErrors = data.rowErrors || []
          if (rowErrors.length > 0) {
            const msgs = rowErrors.map((r) => `Riga ${r.row}: mancano ${r.missing.join(', ')}`)
            setError(`Campi obbligatori mancanti: ${msgs.join(' ; ')}`)
            setRows([])
          } else {
            // initialize rows with tracking fields
            const withStatus = parsed.map((p) => ({ ...p, status: 'pending', errorMessage: '', recipients: [] }))
            setRows(withStatus)
          }
          worker.terminate()
          setLoading(false)
        }
      }
      // handle worker-level errors
      worker.onerror = function (ev) {
        setError('Errore nel parsing del file: ' + (ev && ev.message ? ev.message : String(ev)))
        setRows([])
        try { worker.terminate() } catch (e) { /* ignore */ }
        setLoading(false)
      }

      // start worker - transfer the ArrayBuffer to avoid copying
      try {
        worker.postMessage({ arrayBuffer: data, required }, [data])
      } catch (e) {
        // Fallback if transfer is not supported
        worker.postMessage({ arrayBuffer: data, required })
      }
    } catch (err) {
      setError('Errore nel parsing del file. Assicurati che sia un file xlsx valido con una sheet e colonne appropriate.')
      setRows([])
      setLoading(false)
    }
  }, [])

  const handleSend = useCallback(async () => {
    setError('')
    setSuccess('')
    // prevent double send synchronously
    if (sendingRef.current) return
    if (rows.length === 0) {
      setError('Nessuna riga da inviare. Carica prima un file valido.')
      return
    }

    if (!String(title || '').trim()) {
      setError('Inserisci un titolo per il sollecito.')
      return
    }

    // require email body
    if (!String(emailBody || '').trim()) {
      setError("Inserisci il testo dell'email prima di inviare.")
      return
    }

    // basic pre-send validation: ensure rows still have required fields (defensive)
    const invalid = rows.map((row, idx) => {
      const missing = []
      if (!String(row.dataInizio || '').trim()) missing.push('Data Inizio')
      if (!String(row.pax || '').trim()) missing.push('pax')
      if (!String(row.riferimento || '').trim()) missing.push('Riferimento c/o T.O.')
      if (!String(row.mail1 || '').trim()) missing.push('mail1')
      if (!String(row.voucher || '').trim()) missing.push('Voucher')
      return missing.length > 0 ? `Riga ${idx + 1}: manca ${missing.join(', ')}` : null
    }).filter(Boolean)

    if (invalid.length > 0) {
      setError(`Non è possibile inviare. Problemi nelle righe: ${invalid.join(' ; ')}`)
      return
    }

    // mark as sending (prevent concurrent sends)
    sendingRef.current = true
    setSending(true)
    // helper to update a single row status safely
    const updateRow = (index, patch) => {
      setRows((prev) => {
        if (!prev || index < 0 || index >= prev.length) return prev
        const next = prev.slice()
        next[index] = { ...next[index], ...patch }
        return next
      })
    }
    try {
      // Call server-side bulk sender which performs the same per-row operations
      // The server will append the signature template itself, so we only send rows and the email body
      const res = await FC.service('info').create({ action: 'sendSollecito', rows, emailBody, title })

      if (!res) {
        setError('Risposta vuota dal server durante l\'invio.')
      } else if (!res.ok) {
        setError(`Errore durante l'invio dal server: ${res.message || JSON.stringify(res)}`)
      } else {
        const { results = [], failures: serverFailures = [], successCount: sc = 0 } = res
        // update UI rows according to server results
        results.forEach((r) => {
          if (r.success) {
            updateRow(r.index, { status: 'sent', sentAt: new Date().toISOString(), recipients: r.recipients || [], errorMessage: '' })
          } else {
            updateRow(r.index, { status: 'error', recipients: r.recipients || [], errorMessage: r.errorMessage || 'Errore' })
          }
        })

        if (Array.isArray(serverFailures) && serverFailures.length > 0) {
          setError(`Alcuni invii hanno fallito: ${serverFailures.join(' ; ')}`)
        }

        if (sc > 0) {
          setSuccess(`Invio completato: ${sc} di ${rows.length} righe inviate.`)
          setSentForCurrentLoad(true)
        }
      }
    } catch (err) {
      setError('Errore durante l\'invio. Riprovare più tardi.')
    } finally {
      setSending(false)
      sendingRef.current = false
    }
  }, [rows, emailBody])

  // derived counts for UI
  const sentCount = rows.filter((r) => r.status === 'sent').length
  const errorCount = rows.filter((r) => r.status === 'error').length
  const pendingCount = rows.filter((r) => r.status === 'pending' || r.status === 'sending').length

  // sorting helper: toggle cycle asc -> desc -> none
  const toggleSort = (field) => {
    setSort((s) => {
      if (s.field !== field) return { field, dir: 'asc' }
      if (s.dir === 'asc') return { field, dir: 'desc' }
      return { field: null, dir: null }
    })
  }

  // compute sorted rows for display (non-destructive)
  const sortedRows = useMemo(() => {
    if (!sort.field) return rows
    const copy = rows.slice()
    copy.sort((a, b) => {
      const fa = (a[sort.field] || '').toString().toLowerCase()
      const fb = (b[sort.field] || '').toString().toLowerCase()
      if (fa < fb) return -1
      if (fa > fb) return 1
      // fallback to id to keep stable ordering
      const ia = typeof a.id === 'number' ? a.id : 0
      const ib = typeof b.id === 'number' ? b.id : 0
      return ia - ib
    })
    if (sort.dir === 'desc') copy.reverse()
    return copy
  }, [rows, sort])

  const formatRecipientsForDisplay = (recipients) => {
    if (!recipients) return ''
    const arr = Array.isArray(recipients) ? recipients : String(recipients).split(',').map((s) => s.trim()).filter(Boolean)
    if (arr.length <= 5) return arr.join(', ')
    return `${arr.slice(0, 5).join(', ')} +${arr.length - 5} altri`
  }

  return (
    <Flex fw>
      <Text value='Invio Email Sollecito' bold title size={20} style={{ marginBottom: 20 }} />

      <div style={{ marginBottom: 12, width: '100%' }}>
        <label style={{ display: 'block', marginBottom: 6 }}>
          Titolo sollecito
        </label>
        <input
          type='text'
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{ width: '100%', padding: 8 }}
        />
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', marginBottom: 6 }}>Carica file Excel (.xlsx / .xls)</label>
        <input type='file' accept='.xlsx,.xls' onChange={handleFile} disabled={loading} />
      </div>

      {loading && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ color: '#0066cc' }}>Elaborazione file... attendere</div>
        </div>
      )}

      {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}

      <div style={{ marginBottom: 12, width: '100%' }}>
        <label style={{ display: 'block', marginBottom: 6 }}>Testo email</label>
        <textarea
          value={emailBody}
          onChange={(e) => setEmailBody(e.target.value)}
          placeholder="Scrivi qui il testo dell'email che vuoi inviare."
          style={{ width: '100%', minHeight: 160 }}
        />
      </div>

      <div style={{ marginTop: 8, width: '100%' }}>
        <Text value={`Righe caricate: ${rows.length}`} bold />

        <div style={{ marginTop: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
            <div>Stato: <strong style={{ color: 'green' }}>{sentCount}</strong> inviati / <strong style={{ color: 'red' }}>{errorCount}</strong> errori / <strong>{pendingCount}</strong> in coda</div>
            <button
              onClick={handleSend}
              disabled={loading || sending || sentForCurrentLoad || !String(emailBody || '').trim()}
              style={{ padding: '8px 12px', cursor: loading || sending || sentForCurrentLoad ? 'not-allowed' : 'pointer' }}
            >
              {sending ? 'Invio in corso...' : sentForCurrentLoad ? 'Già inviato' : 'Invia Email'}
            </button>
          </div>
        </div>

        {success && <div style={{ color: 'green', marginTop: 8 }}>{success}</div>}

        {rows.length > 0 && (
          <div style={{ marginTop: 8, overflow: 'auto', maxHeight: 300, border: '1px solid #ddd', padding: 8 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: 6, borderBottom: '1px solid #eee' }}>#</th>
                  <th style={{ textAlign: 'left', padding: 6, borderBottom: '1px solid #eee' }}>Data Inizio</th>
                  <th style={{ textAlign: 'left', padding: 6, borderBottom: '1px solid #eee' }}>Riferimento c/o T.O.</th>
                  <th style={{ textAlign: 'left', padding: 6, borderBottom: '1px solid #eee' }}>Email</th>
                  <th style={{ textAlign: 'left', padding: 6, borderBottom: '1px solid #eee' }}>Voucher</th>
                  <th style={{ textAlign: 'left', padding: 6, borderBottom: '1px solid #eee' }}>Destinatari</th>
                  <th
                    onClick={() => toggleSort('status')}
                    title='Ordina per Stato (clicca per alternare)'
                    style={{ textAlign: 'left', padding: 6, borderBottom: '1px solid #eee', cursor: 'pointer', userSelect: 'none' }}
                  >
                    Stato {sort.field === 'status' ? (sort.dir === 'asc' ? '▲' : '▼') : '↕'}
                  </th>
                  <th style={{ textAlign: 'left', padding: 6, borderBottom: '1px solid #eee' }}>Errore</th>
                  <th style={{ textAlign: 'left', padding: 6, borderBottom: '1px solid #eee' }}>Pax</th>
                </tr>
              </thead>
              <tbody>
                {sortedRows.map((r) => (
                  <tr key={r.id}>
                    <td style={{ padding: 6, borderBottom: '1px solid #f5f5f5' }}>{r.id + 1}</td>
                    <td style={{ padding: 6, borderBottom: '1px solid #f5f5f5' }}>{String(r.dataInizio)}</td>
                    <td style={{ padding: 6, borderBottom: '1px solid #f5f5f5' }}>{String(r.riferimento)}</td>
                    <td style={{ padding: 6, borderBottom: '1px solid #f5f5f5' }}>{String(r.mail1)}</td>
                    <td style={{ padding: 6, borderBottom: '1px solid #f5f5f5' }}>{String(r.voucher || '')}</td>
                    <td style={{ padding: 6, borderBottom: '1px solid #f5f5f5', maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{formatRecipientsForDisplay(r.recipients)}</td>
                    <td style={{ padding: 6, borderBottom: '1px solid #f5f5f5' }}>{String(r.status || '')}</td>
                    <td style={{ padding: 6, borderBottom: '1px solid #f5f5f5', color: 'red' }}>{String(r.errorMessage || '')}</td>
                    <td style={{ padding: 6, borderBottom: '1px solid #f5f5f5' }}>{String(r.pax)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

    </Flex>
  )
}

// export additional pages
export { default as ViewSollecito } from './View'
export { default as SollecitoList } from './List'
